declare const config: any
// getImage
// {string} type
// {object} elmnt
function getImage(type: string, elmnt: any, mobileMode: boolean) {
    let screenshotArray = elmnt.screenshots
    let size

    // Sort the screenshotArray
    screenshotArray = screenshotArray.sort((a: string, b: string) => parseInt(a.split('x')[0], 10) - parseInt(b.split('x')[0], 10))

    if (mobileMode) {
        size = screenshotArray.find((element: any) => element.split('x')[0] < 960)
    } else {
        size = screenshotArray.find((element: any) => element.split('x')[0] > 960)
    }
    // If undefined, i select the 1st item for the mobile version and the last one for the desktop version
    if (size === undefined) {
        if (mobileMode) {
            [size] = screenshotArray
        } else {
            size = screenshotArray[screenshotArray.length - 1]
        }
    }
    return `${config.BASE_URL}/${type}/${elmnt.id}/screenshots/${size}.png`
}

export default getImage
